import {css} from "@panda/css";
import {motion} from "framer-motion";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    reduceMotion: boolean;
    vendorName: string;
}

export function TinderMultiLeadSuccessHeader({reduceMotion, vendorName}: IProps) {
    return (
        <motion.div
            className={bannerStyle}
            initial={reduceMotion ? {opacity: 0} : {opacity: 0, y: -8}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: reduceMotion ? 0.15 : 0.3, ease: [0.4, 0, 0.2, 1]}}
        >
            <span className={iconStyle} aria-hidden>
                <CheckIcon size="2" fill="var(--colors-secondary)" />
            </span>
            <span className={textStyle}>
                <Text variant="body_copy_1" strong color="var(--colors-secondary)">
                    Twoje zapytanie zostało wysłane
                </Text>
                <Text variant="info_txt_1" color="var(--colors-gray-700)">
                    Oczekuj na wiadomość od konsultanta {vendorName}
                </Text>
            </span>
        </motion.div>
    );
}

const bannerStyle = css({
    // Overlays the static header (which stays mounted underneath) so swapping the
    // confirmation in/out never changes the header region height — avoids the layout jump.
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 2,
    py: 2,
    pr: 8,
    backgroundColor: "#cfe3b5",
    md: {
        px: 4,
        pr: 9
    }
});

const iconStyle = css({
    display: "inline-flex",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "4rem",
    borderRadius: "100%",
    backgroundColor: "var(--colors-lime, #ebff00)"
});

const textStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.25
});
import {css} from "@panda/css";
import {motion} from "framer-motion";

import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    reduceMotion: boolean;
    vendorName: string;
}

export function TinderMultiLeadSuccessHeader({reduceMotion, vendorName}: IProps) {
    return (
        <motion.div
            className={bannerStyle}
            initial={reduceMotion ? {opacity: 0} : {opacity: 0, y: -8}}
            animate={{opacity: 1, y: 0}}
            transition={{duration: reduceMotion ? 0.15 : 0.3, ease: [0.4, 0, 0.2, 1]}}
        >
            <span className={iconStyle} aria-hidden>
                <CheckIcon size="2" fill="var(--colors-secondary)" />
            </span>
            <span className={textStyle}>
                <Text variant="body_copy_1" strong color="var(--colors-secondary)">
                    Twoje zapytanie zostało wysłane
                </Text>
                <Text variant="info_txt_1" color="var(--colors-gray-700)">
                    Oczekuj na wiadomość od konsultanta {vendorName}
                </Text>
            </span>
        </motion.div>
    );
}

const bannerStyle = css({
    // Overlays the static header (which stays mounted underneath) so swapping the
    // confirmation in/out never changes the header region height — avoids the layout jump.
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 2,
    py: 2,
    pr: 8,
    backgroundColor: "#cfe3b5",
    md: {
        px: 4,
        pr: 9
    }
});

const iconStyle = css({
    display: "inline-flex",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "4rem",
    borderRadius: "100%",
    backgroundColor: "var(--colors-lime, #ebff00)"
});

const textStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.25
});
